import { InjectionToken, Signal } from '@angular/core';
import { NavBadge } from './nav-descriptor';

/**
 * Supplies live badge state for navigation nodes. A node's static
 * `NavDescriptor.badge` is the fallback; a registered provider can
 * override/compute the badge reactively (e.g. an unread count or a
 * severity rollup). Returns `null` when the node has no badge.
 */
export interface NavBadgeProvider {
  badgeFor(navId: string): Signal<NavBadge | null>;
}

/**
 * Multi-provider token for {@link NavBadgeProvider} implementations.
 */
export const NAV_BADGE_PROVIDER = new InjectionToken<NavBadgeProvider>(
  'NAV_BADGE_PROVIDER',
);
